// @ts-strict-ignore
import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[heightOffset]'
})
export class HeightDirective implements OnInit, OnDestroy {
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  @Input()
  public heightOffset: number;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(20)).subscribe((evt) => {
      this.setScrollbarHeight((evt.currentTarget as Window).innerHeight);
    });
    this.setScrollbarHeight(window.innerHeight);
  }

  private setScrollbarHeight(windowHeight: number) {
    this.elementRef.nativeElement.style.height = `${windowHeight - this.heightOffset}px`;
  }

  ngOnDestroy(): void {
    this.resizeSubscription$.unsubscribe();
  }
}
